<template>
  <b-container>
    <ProfileHero :artist="artist" v-if="artist" />
    <ArtistProfileTabs :artist="artist" v-if="artist" />

    <div class="content">
      <b-row v-if="artist" align-v="center" class="py-2">
        <b-col class="flex artist-header">
          <img :src="artist.avatar_image" class="avatar">
          <div>
            <h2>{{ artist.name }}</h2>
            <h4>@{{ artist.handle }}</h4>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="artist">
        <b-col v-html="formatText(this.artist.bio)" />
      </b-row>
    </div>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .content {
    padding-left: 6px;
    padding-right: 6px;
    @include media-breakpoint-down(sm) {
      font-size: .9em;
    }
  }
  .artist-header {
    margin-bottom: 20px;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  img.avatar {
    width: 78px;
    height: 78px;
    border-radius: 100%;
    margin-right: 18px;
    box-shadow: 2px 0px 12px #000;
    @include media-breakpoint-down(sm) {
      width: 58px;
      height: 58px;
    }
    @include media-breakpoint-down(xs) {
      width: 38px;
      height: 38px;
    }
  }

  h2 {
    text-shadow: 3px 3px 0 #000;
    font-size: 3rem;
    font-family: 'AvenirHeavy';
    margin: 0;
    @include media-breakpoint-down(sm) {
      font-size: 2rem;
    }
    @include media-breakpoint-down(xs) {
      font-size: 1.5rem;
    }
  }
  p {
    line-height: 2
  }
</style>

<script>
import { formatText } from '@/utils/textformat'

import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'

export default {
  name: 'ArtistAbout',
  components: {
    ArtistProfileTabs,
    ProfileHero
  },
  data () {
    return {
      artist: null
    }
  },
  computed: {
    isCurrentUser () {
      return this.artist && this.artist.profile.id === this.$store.getters['profile/currentUser'].id
    }
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      try {
        this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
      } catch (e) {
        let message = 'Error getting artist information'
        if (e.response && e.response.status === 404) message = 'Artist account no longer exists'
        this.$store.dispatch('flash/showMessage', { message, type: 'error' })
        this.$router.replace({'name': 'discover'})
      }
    },
    formatText
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/About.vue